import { z } from "zod";

import { SpecialVersionType } from "../enums.js";
import {
  SemanticProjectId,
  SemanticProjectVersionId,
} from "../idTypeBrands.js";

export const SemanticProjectVersionString = z.union([
  SemanticProjectVersionId,
  z.nativeEnum(SpecialVersionType),
]);
export type SemanticProjectVersionString = z.infer<
  typeof SemanticProjectVersionString
>;

export type SemanticProjectVersionLocator =
  | { version: SemanticProjectVersionId }
  | { semanticProjectId: SemanticProjectId; version: SpecialVersionType };

export const SemanticProjectMapping = z.record(
  SemanticProjectId,
  SemanticProjectVersionString,
);
export type SemanticProjectMapping = z.infer<typeof SemanticProjectMapping>;

export function versionStringFromSemanticMapping(
  semanticProjectMapping: SemanticProjectMapping | null | undefined,
  semanticProjectId: SemanticProjectId | null | undefined,
): SemanticProjectVersionString | null {
  if (semanticProjectMapping == null || semanticProjectId == null) {
    return null;
  }
  return semanticProjectMapping[semanticProjectId] ?? null;
}
